import { render, staticRenderFns } from "./ChatTour.vue?vue&type=template&id=4c01772e&scoped=true"
import script from "./ChatTour.vue?vue&type=script&lang=js"
export * from "./ChatTour.vue?vue&type=script&lang=js"
import style0 from "./ChatTour.vue?vue&type=style&index=0&id=4c01772e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01772e",
  null
  
)

export default component.exports